import { useCallback, useState } from "react";
import useUploadKlydoLoopMutation from "./useUploadKlydoLoopMutation";
import { getMediaType } from "../../../utils/util";
import { UploadResponse } from "../../../api/uploads";

const MAX_FILE_SIZE_BYTES = 70000000;

export const isValidLoopFile = (file: File) =>
  ["video/mp4", "image/gif"].includes(file.type) &&
  file.size <= MAX_FILE_SIZE_BYTES;

const useUploadKlydoLoop = () => {
  const [uploadResponse, setUploadResponse] = useState<
    (UploadResponse & { fileName: string }) | null
  >();
  const [errorMessage, setErrorMessage] = useState("");

  const { mutate: uploadKlydoLoopMutation, isPending: isLoadingUrl } =
    useUploadKlydoLoopMutation({
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Something went wrong";
        setUploadResponse(null);
        setErrorMessage(errorMessage);
      },
      onSuccess: (response, variable) => {
        setUploadResponse({ ...response, fileName: variable.fileName! });
      },
    });

  const resetUploadResponse = useCallback(() => {
    setUploadResponse(null);
    setErrorMessage("");
  }, []);

  const uploadFile = useCallback(
    (file: File, normalize: boolean) => {
      if (!isValidLoopFile(file)) return;
      const reader = new FileReader();
      reader.onload = () => {
        uploadKlydoLoopMutation({
          file: reader.result as string,
          fileName: file.name,
          fileType: getMediaType(reader.result as string),
          normalize,
        });
      };
      reader.readAsDataURL(file);
    },
    [uploadKlydoLoopMutation],
  );
  return {
    uploadFile,
    uploadResponse,
    isLoadingUrl,
    errorMessage,
    resetUploadResponse,
  };
};
export default useUploadKlydoLoop;
